import _ from 'lodash';
import React from 'react';
import { List, Segment } from 'semantic-ui-react';
import GolferHcpLabel from './GolferHcpLabel';
import LineupBuilder from './LineupBuilder';

const MAIN_COLORS = [
  "red",
  "blue",
  "green",
  "yellow",
  "black",
  "white",
  "gray",
  "orange",
  "purple",
  "pink",
  "brown"
];

const _applyLineBuilder = true

const GolfLineupSimple = (props) => {

  const isColor = (str) => _.includes(MAIN_COLORS, _.toLower(str))

  const { groups, round, items } = props
  const { golfCourse: roundGolfCourse } = round ?? {}

  const _additionalProp = ['courseRoundHandicap']

  if (_applyLineBuilder) {
    return <LineupBuilder
      // golfer_partners={golfer_partners}
      groupCount={2}
      // handleUpdateArray={handleUpdateArray}
      items={items}
      propsToShow={_additionalProp}
      selectedRoundType={round.name}
    />
  }

  const golferHandicapLabel = (golfer) => {
    const { courseHandicaps, courseTeeboxes } = golfer
    const _courseHandicap = courseHandicaps ? courseHandicaps[roundGolfCourse] : '-'
    const _courseTeebox = courseTeeboxes ? courseTeeboxes[roundGolfCourse] : '-'
    const defaultColor = 'grey'
    const color = _courseTeebox && isColor(_courseTeebox) ? _courseTeebox : defaultColor
    const ghProps = { golfer, color: color, displayHandicap: _courseHandicap }
    return <GolferHcpLabel ghProps={ghProps} />
  }

  const simpleLineup = () => {
    if (groups && _.size(groups) > 0) {
      const segs = []
      _.forEach(groups, (group, key) => {
        const { items } = group ?? {}
        if (items) {
          const listItems = []
          _.forEach(items, (golfer) => {
            const { name, firstName, lastName } = golfer
            const _name = firstName && lastName ? firstName + ' ' + lastName : name
            const _item = <div>{golferHandicapLabel(golfer)}{_name}</div>
            listItems.push(<List.Item content={_item} />)
          })
          segs.push(<Segment.Group>
            <Segment>{_.startCase(key)}</Segment>
            <Segment><List divided relaxed size={'small'}>{listItems}</List></Segment>
          </Segment.Group>)
        }
      })
      return <Segment basic className={'golf-lineup-simple'}>
        {segs}
      </Segment>
    }
  }

  return simpleLineup()


}

export default GolfLineupSimple